import React, { useEffect, useState, useCallback } from 'react';
import { __ } from '@wordpress/i18n';
import { pathOr } from 'ramda';
import NumberFlow from '@number-flow/react';

// store
import { useStoreValue } from '../../store';

// components
import DashboardService from '../../service/dashboard-service';
import SoccorsiPreInstructorTableAsync from './components/SoccorsiPreInstructorTableAsync';

const SoccorsoIstruttorioPreInstructor = () => {
    const [mainStats, setMainStats] = useState({});
    const userData = useStoreValue('userData');

    const getStats = (data) => {
        if (data.status === 'SUCCESS') {
            setMainStats(data.data);
        }
    }

    const errGetStats = () => {}

    const getStatValue = useCallback((key, fallback = '') => {
        return pathOr(fallback, [key], mainStats);
    }, [mainStats]);

    useEffect(() => {
        DashboardService.getAmendmentsStats(getStats, errGetStats);
    }, []);

    return(
        <div className="appPage">
            <div className="appPage__pageHeader">
                <h1>{__('Richieste di integrazioni', 'htr')}</h1>
            </div>

            <div className="appPage__spacer"></div>

            <div className="appPageSection statsBigBadges">
                <h2>{__('Riepilogo', 'htr')}</h2>
                <div className="statsBigBadges__grid applStats">
                    <div className="statsBigBadges__gridItem">
                        <span>{__('Totale richieste', 'htr')}</span>
                        <span><NumberFlow
                            value={getStatValue('totalAmendments', 0)}
                            format={{ notation: 'compact' }}
                            locales="it-IT"/></span>
                    </div>
                    <div className="statsBigBadges__gridItem">
                        <span>{__('In attesa risposta', 'htr')}</span>
                        <span><NumberFlow
                            value={getStatValue('waitingForResponseAmendments', 0)}
                            format={{ notation: 'compact' }}
                            locales="it-IT"/></span>
                    </div>
                    <div className="statsBigBadges__gridItem">
                        <span>{__('Risposte ricevute', 'htr')}</span>
                        <span><NumberFlow
                            value={getStatValue('responseReceivedAmendments', 0)}
                            format={{ notation: 'compact' }}
                            locales="it-IT"/></span>
                    </div>
                    <div className="statsBigBadges__gridItem">
                        <span>{__('Tempo medio di risposta', 'htr')}</span>
                        <span><NumberFlow
                            value={getStatValue('averageResponseDays', 0)}
                            format={{ notation: 'compact' }}
                            suffix={` ${__('giorni', 'htr')}`}
                            locales="it-IT"/></span>
                    </div>
                    <div className="statsBigBadges__gridItem">
                        <span>{__('Scadute', 'htr')}</span>
                        <span><NumberFlow
                            value={getStatValue('expiredAmendments', 0)}
                            format={{ notation: 'compact' }}
                            locales="it-IT"/></span>
                    </div>
                    <div className="statsBigBadges__gridItem">
                        <span>{__('Richieste in scadenza (48h)', 'htr')}</span>
                        <span><NumberFlow
                            value={getStatValue('expiringRequestsIn48Hours', 0)}
                            format={{ notation: 'compact' }}
                            locales="en-US"/></span>
                    </div>
                </div>
            </div>

            <div className="appPage__spacer"></div>

            <div className="appPageSection">
                <h2>{__('Da valutare', 'htr')}</h2>
                <SoccorsiPreInstructorTableAsync userId={userData.id}/>
            </div>
        </div>
    )
}

export default SoccorsoIstruttorioPreInstructor;